<template>
  <div
    :class="{
      'py-4': type === 'page'
    }"
  >
    <h2
      class="text-Light-01-Text-Primary text-4xl font-roc-grotesk-bold leading-7.5"
    >
      <slot
        name="headline"
      />
    </h2>
    <p
      class="text-Light-02-Text-Secondary text-xs font-plex leading-6.5"
    >
      <slot
        name="subline"
      />
    </p>
  </div>
</template>

<script setup lang="ts">
interface Props {
  type?: 'modal' | 'page' | 'none'
}

const props = withDefaults(defineProps<Props>(), {
  type: 'page'
})
</script>
